import { authClient, API } from "../index";

// Get all empleos
export const getEmpleos = () => {
  return authClient().get(`${API}/empleo?getDisabled=true`);
};

// Get empleo by id
export const getEmpleoById = (id) => {
  return authClient().get(`${API}/empleo/${id}?all=true`);
};

// Delete empleo
export const deleteEmpleo = (id) => {
  return authClient().delete(`${API}/empleo/${id}`);
};

// Create empleo
export const postEmpleo = async (empleo) => {
  return authClient().post(`${API}/empleo`, empleo);
};

// Update empleo
export const updateEmpleo = async (id, empleo) => {
  return authClient().put(`${API}/empleo/${id}`, empleo);
};

// Change status empleo
export const changeStatusEmpleo = async (id, active) => {
  return authClient().put(`${API}/empleo/change-status/${id}`, { active });
};

// Change validate empleo
export const changeStatusValidateEmpleo = async (id, validate) => {
  return authClient().put(`${API}/empleo/change-validate/${id}`, { validate });
};
